import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=c2265cb8&scoped=true&"
import script from "./TableHeader.vue?vue&type=script&lang=js&"
export * from "./TableHeader.vue?vue&type=script&lang=js&"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=c2265cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2265cb8",
  null
  
)

export default component.exports